import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Console } from 'console';
import { debounceTime } from 'rxjs/operators';
import { DialogBase, RentalInfo } from 't4core';
import { CampaignInfo, CampaignType, DiscountReasonInfo, GenerateVoucherResult } from 't4core';
import { RentalDialog } from '../../../../t4common/';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { DiscountValueType } from 't4core';


@Component({
  selector: 'createCampaignDialog',
  templateUrl: 'createCampaignDialog.html',
  styleUrls: ['createCampaignDialog.css']
})
export class CreateCampaignDialog extends DialogBase {

  public result: CampaignInfo;
  public selectedReason: string;
  public Reasons: any = [];
  public CampaignValue: CampaignInfo;
  public campaignInfo: CampaignInfo = new CampaignInfo();
  public DefaultTrough: any = [];
  public campaignvalue: string;
  public type: string;
  public ValidMonths: number;


  inputdiscountcode = new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(15)]);
  inputValidFrom = new FormControl('', [Validators.required, Validators.minLength(1)]);
  inputValidThrough = new FormControl('', [Validators.required, Validators.minLength(1)]);
  inputMonths = new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]);

  amountValue = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]);
  procentValue = new FormControl('', [Validators.required, Validators.min(1), Validators.max(100), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]);
  timeValue = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^(0|[1-9]\d*)?$/)]);

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CreateCampaignDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("CreateCampaignDialog");
    this.result = data;
    this.campaignInfo.ValidFrom = moment().startOf('day');
    this.campaignInfo.ValidThrough = moment().startOf('day').add(1, 'years');
    this.campaignInfo.CreatedAt = moment().startOf('day');

    this.campaignInfo.RequireCode = true;
    this.campaignInfo.GenerationPattern = 0;
    this.campaignInfo.Type = CampaignType.Campaign;

    this.campaignInfo.ValueType = DiscountValueType.Monetary;
    this.campaignInfo.Value = 100;
    this.ValidMonths = 12;
  }

  async ngOnInit() {
    this.GetDiscountCode();
    this.loadReasons();
  }

  public loading: any = {
    Campaign: false,
    UsedSubCampaigns: false,
    Reasons: false,
    Templates: false,
    CampaignControl: false, 
  };

  private async loadReasons(): Promise<Boolean> {
    this.loading.Reasons = true;
    this.Reasons = await this.Api.get<DiscountReasonInfo>("/Campaign/GetDiscountReasons");
    this.campaignInfo.ReasonId = this.Reasons[0].Id;
    this.loading.Reasons = false;

    return true;
  }

  public async createCampaign() {

    // Does the campaign exists ?
    this.loading.CampaignControl = true;
      var campaign = await this.Api.get<DiscountReasonInfo>("/Campaign/GetDiscount", { code: this.campaignInfo.DiscountCode });
    this.loading.CampaignControl = false;

    if (campaign == null) {
      this.campaignInfo.IsTemplate = this.campaignInfo.Type == 2 ? false : true;
      // this.campaignInfo.ValidThrough = moment().startOf('day').add(1, 'years');

      this.campaignInfo.ValidThrough = this.campaignInfo.IsTemplate ? moment().startOf('day').add(this.ValidMonths, 'month') : this.campaignInfo.ValidThrough

      var token = this.UI.beginLoading("T4.Campaigns.campaign.msgsubcampaigns", "Generating Campaigns", null);
      this.loading.createCampaign = true;

      if (this.campaignInfo.ValueType == DiscountValueType.Time)
        this.campaignInfo.Value = this.campaignInfo.Value * 60 * 60;

      var ret = await this.Api.post<CampaignInfo>("/Campaign/CreateCampaign", this.campaignInfo, this.type);
      if (ret == null)
        this.UI.snackBarLocal('T4.Campaigns.CampaignDetails.msgerrorcreatecampaign', 'ERROR trying creating campaign')

      this.loading.createCampaign = false;
      this.UI.loaderCompleted(token);
      this.dialogRef.close(ret);
    }
    else {
      this.UI.snackBarLocal('T4.Campaigns.CampaignDetails.msgSettingsCampaignnameAlreadyUsed', 'ERROR Campaign name already used')
    }
  }

  public async GetDiscountCode() {
    this.campaignInfo.DiscountCode = await this.Api.get<string>("/Campaign/GenerateDiscountCode");
  }
}
